const defaultApiBase = '/backend/analytics-api.php';
const apiBase = import.meta.env.VITE_ANALYTICS_API_URL || defaultApiBase;

const VISITOR_KEY = 'lb-visitor-token';
const SESSION_KEY = 'lb-session-token';

function read(storage, key) {
  try {
    return storage.getItem(key) || '';
  } catch (error) {
    return '';
  }
}

function write(storage, key, value) {
  try {
    if (value) storage.setItem(key, value);
  } catch (error) {
    /* private mode — tracking still works, it just can't group sessions */
  }
}

/**
 * Reports one page view. The visitor token lives in localStorage (stable
 * across visits) and the session token in sessionStorage (per browser tab
 * run); the server rolls the session over after 30 idle minutes anyway.
 *
 * Never rejects: analytics must not break navigation.
 */
export async function trackPageView({ path, title } = {}) {
  if (typeof window === 'undefined') return;

  // The admin is a private tool — don't record it as storefront traffic.
  const currentPath = path || window.location.pathname;
  if (currentPath.startsWith('/admin')) return;

  try {
    const response = await fetch(apiBase, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        path: currentPath,
        url: window.location.href,
        title: title || document.title,
        referrer: document.referrer || '',
        locale: navigator.language || '',
        visitorToken: read(window.localStorage, VISITOR_KEY),
        sessionToken: read(window.sessionStorage, SESSION_KEY),
      }),
    });

    if (!response.ok) return;

    const payload = await response.json();
    write(window.localStorage, VISITOR_KEY, payload.visitorToken);
    write(window.sessionStorage, SESSION_KEY, payload.sessionToken);
  } catch (error) {
    /* offline or blocked — nothing to do */
  }
}
